import { showView } from '../actions/publicActions';
import { lazyInitializeDataProviderOpx } from 'owa-data-provider-opx';
import { PopoutChildState, setPopoutChildState } from 'owa-popout-v2';

export function deepLinkDataProviderRouteHandler() {
    lazyInitializeDataProviderOpx.importAndExecute().then(() => {
        showView('DataProvider');
        setPopoutChildState(PopoutChildState.Ready);
    });
}
